import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {ObjectFactory} from "@commons/types";
import {ArrotondamentiRangeRecord} from "@commons/mapping/ArrotondamentiRangeRecord";

export type TipoArrotondamento = "MINUTARIO" | "AL_QUARTO" | "ALLA_MEZZA" | "DA_TABELLA" | "AL_QUINTO" | "AL_DECIMO";

export interface TabellaArrotondamentiRecord extends URIAndTrace {
    idAziendaTabelle: number;
    idArrotondamenti: number;
    descrizione: string;
    tipoArrEntrata: TipoArrotondamento;
    tipoArrUscita: TipoArrotondamento;
    offset: number;
    arrotondaOrdinarie: boolean;
    nonAarrotondareSeEntrataMaggUscita: boolean;
    ranges?: ArrotondamentiRangeRecord[];
}

export class TabellaArrotondamentiRecord {
    static factory: ObjectFactory<TabellaArrotondamentiRecord> = (json?) => {
        return {
            idAziendaTabelle: (json && json.idAziendaTabelle) ? json.idAziendaTabelle : 0,
            idArrotondamenti: (json && json.idArrotondamenti) ? json.idArrotondamenti : 0,
            descrizione: (json && json.descrizione) ? json.descrizione : '',
            tipoArrEntrata: (json && json.tipoArrEntrata) ? json.tipoArrEntrata : 'MINUTARIO',
            tipoArrUscita: (json && json.tipoArrUscita) ? json.tipoArrUscita : 'MINUTARIO',
            offset: (json && json.offset) ? json.offset : 0,
            arrotondaOrdinarie: (json && json.arrotondaOrdinarie) ? json.arrotondaOrdinarie : false,
            nonAarrotondareSeEntrataMaggUscita: (json && json.nonAarrotondareSeEntrataMaggUscita) ? json.nonAarrotondareSeEntrataMaggUscita : false,
            URI: null,
        };
    }

    static arrotonda = (that: TabellaArrotondamentiRecord, timbratura: number | null, verso: 'ENT' | 'USC', offset: number = 0): number | null => {
        /*
            if (offset === undefined) {
                offset = 0;
            }
        */
        if (!that.ranges || timbratura === null)
            return null;
        let index = 0;
        for (let ind0 = 0; ind0 < that.ranges.length; ++ind0) {
            index = ind0;
            if (ArrotondamentiRangeRecord.getFinoA(that.ranges[ind0], -offset) >= timbratura) {
                break;
            }
        }
        if (verso === 'ENT') {
            return ArrotondamentiRangeRecord.getEntrata(that.ranges[index], -offset);
        } else {
            return ArrotondamentiRangeRecord.getUscita(that.ranges[index], -offset);
        }
    };
}